import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/api';
import { getAttentionItems, type AttentionFilters } from '../api/get-attention-items';

export function useAttention(filters: AttentionFilters = {}) {
  return useQuery({
    queryKey: queryKeys.attention.list(filters),
    queryFn: () => getAttentionItems(filters),
  });
}

/**
 * Count shown on the sidebar badge.
 *
 * It reuses the unfiltered attention query, so opening the Attention screen
 * hits a warm cache instead of refetching the same list.
 */
export function useAttentionCount(): number {
  const { data } = useQuery({
    queryKey: queryKeys.attention.list({}),
    queryFn: () => getAttentionItems(),
    staleTime: 60_000,
  });

  return data?.length ?? 0;
}
